"use strict";

module.exports = {
    backinstockEvents: function () {
        $(document).ready(function () {
            if (!$(".attributes").data("isbisenabled")) {
                return;
            }

            if ($("#bis-button-data").data("is-sfra")) {
                require("@bis/backinstock/bisSFRA").initializeEvents();
            }

            $("input").on("click", function () {
                var url = $("#bisWishlist").data("url");

                if (!url) {
                    return;
                }

                if ($("#bisWishlist:checkbox:checked").length > 0) {
                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: {
                            isChecked: true
                        }
                    });
                } else {
                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: {
                            isChecked: false
                        }
                    });
                }
            });
        });
    }
};
